import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const SurveyDiagnosesToDiagnosesQuestionKeysMap: Record<
  SurveyName.ADMISSIONS_INTAKE,
  string[]
> = {
  [SurveyName.ADMISSIONS_INTAKE]: [
    'medicalConditions',
    'psychiatricDiagnoses',
    'EDdiagnoses',
    'intake_food_allergies',
  ],
};
